import axios from 'axios'
import qs from 'qs'
import { Notification, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_API : '/', // api 的 base_url
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 60000, // 请求超时时间
  withCredentials: true
})
console.log(process.env.BASE_API)
// request拦截器
service.interceptors.request.use(
  config => {
    // console.log('config', config)
    if (getToken()) {
      config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // config.headers['Content-Type'] = 'application/json'
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
    console.log('request拦截器 config:', config)
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    // console.log('response 拦截器:' + JSON.stringify(response))
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message
      })
      return Promise.reject(new Error('error'))
    } else {
      const rcode = response.data.code
      // const requestUrl = response.config.url  && requestUrl !== 'merchant/getMerchant.do'
      if (rcode === -1) {
        MessageBox.confirm(
          response.data.msg,
          '系统提示',
          {
            confirmButtonText: '重新登录',
            showCancelButton: false,
            closeOnClickModal: false,
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      // ie9
      if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
        try {
          // eslint-disable-next-line no-param-reassign
          response.data = JSON.parse(response.request.responseText)
        } catch (e) {
          console.log('ie', e)
          // ignored
        }
      }
      return response.data
    }
  },
  error => {
    let code = 0
    try {
      console.log('error:' + error)
      code = error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: '网络请求超时',
          duration: 2500
        })
        return Promise.reject(error)
      }
      if (error.toString().indexOf('Error: Network Error') !== -1) {
        Notification.error({
          title: '网络请求错误',
          duration: 2500
        })
        return Promise.reject(error)
      }
    }
    if (code === 401) {
      MessageBox.confirm(
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
    } else {
      const errorMsg = error.response.data.message
      if (errorMsg !== undefined) {
        Notification.error({
          title: errorMsg,
          duration: 3000
        })
      }
    }
    return Promise.reject(error)
  }
)

export function get (url, params, config = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params: params,
      ...config
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}

// 封装post请求
export function post (url, params, config = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, qs.stringify(params), {
      ...config
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export { service }



// WEBPACK FOOTER //
// ./src/utils/request.js